export default __webpack_public_path__ + "static/media/FurnitureItem1.ecc01cdb.png";